// Backend id for the "Other" referral source. When selected, the UI reveals a
// free-text field whose value is sent to the API as the existing `referredBy` string.
export const REFERRAL_SOURCE_OTHER_ID = 20;
